import { useState, useEffect } from "react";
import { useToken } from "./useToken";

export const useUser = () => {
  const [token, setToken] = useToken();

  const getPayloadFromToken = (token) => {
    try {
      const encodedPayload = token.split(".")[1];
      return JSON.parse(atob(encodedPayload));
    } catch (e) {
      return null;
    }
  };

  const [user, setUser] = useState(() => {
    if (!token) return null;
    return getPayloadFromToken(token);
  });

  useEffect(() => {
    if (!token) {
      setUser(null);
      return;
    }
    const payload = getPayloadFromToken(token);
    if (!payload) {
      setToken(null);
    }
    setUser(payload);
  }, [token]);

  return user;
};
